// src/components/Feature.js
import React from 'react';
import { useInView } from 'react-intersection-observer';
import './Features.css';

const features = [
    {
        title: "TICT Based Cold Chain",
        items: [
            "TICT Based Cold Rooms",
            "TICT Based Chiller Rooms",
            "TICT Based Freezer Rooms",
            "TICT Based Cold Warehouse"
        ]
    },
    // Add other features as needed
    {
        title: "Cold Rooms & Large Cold Storages",
        items: []
    },
    {
        title: "Cold Chain Projects",
        items: []
    },
    {
        title: "Ice cream Cold Rooms",
        items: []
    },
    {
        title: "Fruits & Vegetables Cold Storages",
        items: []
    },
    {
        title: "Seeds Cold Storage",
        items: []
    },
    {
        title: "Temperature Controlled Warehouses/ Cold Warehouses Projects",
        items: []
    },
    {
        title: "Blast Freezers, Blast Chillers, IQF",
        items: []
    },
    {
        title: "Special Application HVACR Projects",
        items: []
    },
    {
        title: "Frozen Food Cold Storages",
        items: []
    },
    {
        title: "Ripening Chambers",
        items: []
    },
    {
        title: "Mobile Cold Chain Solutions",
        items: []
    }
];

const Feature = () => {
    return (
        <div className="feature-container">
            <h2 className="feature-title">Solutions we Offer</h2>
            <div className="feature-grid">
                {features.map((feature, index) => (
                    <FeatureItem
                        key={index}
                        title={feature.title}
                        items={feature.items}
                        index={index}
                    />
                ))}
            </div>
        </div>
    );
};

const FeatureItem = ({ title, items, index }) => {
    const { ref, inView } = useInView({
        triggerOnce: false, // Allows animation to trigger multiple times
        threshold: 0.1
    });

    return (
        <div
            ref={ref}
            className={`feature-item ${inView ? 'in-view' : ''}`}
            style={{ '--order': index }}
        >
            <h3>{title}</h3>
            {items.length > 0 && (
                <ul className="feature-list">
                    {items.map((item, subIndex) => (
                        <li key={subIndex}>{item}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Feature;
